/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Button, Card, Col, Form, FormGroup, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Fetch, IFetchProps } from "../../services/Fetch";
import { endpoints } from "../../data/endpoints";
import DataTable from "react-data-table-component";
import { customStyles } from "../../components/tables/TableStyles";
import PaginationComponent from "../../components/tables/PaginationComponent";
import { Brand } from "../../components/forms/dataForms";
import { rates } from "../administration/import/data";
import Swal from "sweetalert2";
import { AlertSuccess } from "../../components/SweetAlerts/Alerts";

const TableGoals = ({ load, setLoad, setDataEdit }: any) => {
  const { token } = useSelector((state: any) => state.auth.user);
  const [data, setData] = useState<any>([]);
  const [columns, setColumns] = useState<any>([]);
  const [total, setTotal] = useState<number>(0);
  const [rate, setRate] = useState<string | undefined>(undefined);
  const [showOptions, setShowOptions] = useState<boolean>(false);

  const [since, setSince] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);

  useEffect(() => {
    if (rate) {
      getData();
    }
  }, [since, limit, rate, showOptions]);

  useEffect(() => {
    if (load) {
      getData();
    }
  }, [load]);

  const getData = async () => {
    const propsFetch: IFetchProps = {
      Endpoint: `${endpoints.goals.main}?codeRate=${rate}&since=${since}&limit=${limit}`,
      method: "GET",
      token,
    };
    const response: any = await Fetch(propsFetch);
    if (response.statusCode && response.statusCode === 200) {
      setColumnsData(response.data);
      setLoad(false);
    }
  };

  const deleteGoal = async (id: any) => {
    const propsFetch: IFetchProps = {
      Endpoint: `${endpoints.goals.main}/${id}`,
      method: "DELETE",
      token,
    };
    const response: any = await Fetch(propsFetch);
    if (response.statusCode && response.statusCode === 200) {
      getData();
      AlertSuccess("Meta eliminada exitosamente");
    }
  };

  const handleEdit = (item: any, period: any) => {
    setDataEdit({
      codeRate: rate,
      year: period.split("-")[0],
      semester: period.split("-")[1],
      percentaje: item[period],
      programFilters: item.idProgram,
      edit: true,
      id: item.id,
    });
  };

  const handleDelete = (id: any) => {
    Swal.fire({
      title: "¿Estas Seguro?",
      text: "¿Quieres eliminar a este registro?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Eliminar",
      cancelButtonText: "No, Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteGoal(id);
      }
    });
  };

  const setColumnsData = (datatable: any) => {
    let programs: any[] = [];
    let periods: any[] = [];
    const columnsData = [
      {
        name: "Cod. Programa",
        selector: (row: any) => [row.programCode],
        sortable: true,
        cell: (row: any) => (
          <span>
            <span className="text-light tx-13">{row.programCode ?? ""}</span>
          </span>
        ),
      },
      {
        name: "Programa",
        selector: (row: any) => [row.program],
        sortable: true,
        cell: (row: any) => (
          <span>
            <span className="text-light tx-13">{row.program ?? ""}</span>
          </span>
        ),
      },
      {
        name: "Modalidad",
        selector: (row: any) => [row.modality],
        sortable: true,
        cell: (row: any) => (
          <span>
            <span className="text-light tx-13">{row.modality ?? ""}</span>
          </span>
        ),
      },
      {
        name: "Nivel",
        selector: (row: any) => [row.level],
        sortable: true,
        cell: (row: any) => (
          <span>
            <span className="text-light tx-13">{row.level ?? ""}</span>
          </span>
        ),
      },
    ];

    datatable.forEach((element: any) => {
      const index = programs.findIndex(
        (item: any) => item.idProgram === element.program._id
      );

      if (index > -1) {
        programs[index] = {
          ...programs[index],
          [`${element.year}-${element.semester}`]: element.targetPercentage,
        };
      } else {
        programs = [
          ...programs,
          {
            id: element.id,
            idProgram: element.program._id,
            program: element.program.program_name,
            programCode: element.program.code_snies_program,
            modality: element.program.modality,
            level: element.program.academic_level,
            [`${element.year}-${element.semester}`]: element.targetPercentage,
          },
        ];
      }

      // Lsita de periodos disponibles
      if (
        !periods.some(
          (period: any) => period === `${element.year}-${element.semester}`
        )
      ) {
        periods.push(`${element.year}-${element.semester}`);
      }
    });

    for (let index = 0; index < periods.length; index++) {
      const col = periods[index];

      columnsData.push({
        name: col,
        selector: (row: any) => [row[col]],
        sortable: true,
        cell: (row: any) => (
          <span className="d-flex align-items-center">
            {row[col] && (
              <>
                {showOptions && (
                  <i
                    className="fa fa-trash text-danger me-1"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleDelete(row.id)}
                  ></i>
                )}
                <span className="text-light tx-13 px-4">
                  {row[col] ? `${row[col]}%` : ""}
                </span>
                {showOptions && (
                  <i
                    className="fa fa-pen text-success ms-1"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleEdit(row, col)}
                  ></i>
                )}
              </>
            )}
          </span>
        ),
      });
    }

    setColumns(columnsData);
    setData(programs);
    setTotal(10);
  };

  return (
    <Col md={12} xl={12} xs={12} sm={12}>
      <Card>
        <Card.Header>
          <h3 className="card-title">PROYECCION DE METAS</h3>
        </Card.Header>
        <Card.Body>
          <div>
            <Row style={{ alignItems: "end" }}>
              <Col xs={12} md={12} lg={8}>
                <FormGroup className="form-group">
                  <Form.Label className="form-label text-dark">
                    Tasa a proyectar
                  </Form.Label>
                  <Brand
                    Options={rates}
                    Placeholder="Seleccionar año"
                    Name="codeRate"
                    Onchange={(opt: any) => setRate(opt.value)}
                  />
                </FormGroup>
              </Col>
              <Col xs={12} md={12} lg={4}>
                <Button
                  className="btn btn-primary w-100 mb-3"
                  style={{ marginTop: "auto" }}
                  onClick={() => setShowOptions(!showOptions)}
                  disabled={data.length === 0}
                >
                  {showOptions ? "Ocultar opciones" : "Mostar opciones"}
                </Button>
              </Col>
            </Row>
            <div className="table-responsive ">
              <span className="datatable">
                <DataTable
                  columns={columns}
                  data={data}
                  customStyles={customStyles}
                  noDataComponent={
                    <div style={{ margin: "50px 10px" }}>
                      No se encontraron datos de proyeccion de metas
                    </div>
                  }
                />
                {data.length > 0 && (
                  <PaginationComponent
                    since={since}
                    setSince={setSince}
                    limit={limit}
                    setLimit={setLimit}
                    total={total}
                  />
                )}
              </span>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default TableGoals;
